import { Link } from 'react-router-dom';

const ACCENTS = {
  cyan: { border: 'border-[#F29B3D]/20', bg: 'bg-[#F29B3D]/[0.07]', icon: 'text-[#F29B3D]', topBar: 'via-[#F29B3D]/40' },
  green: { border: 'border-[#F29B3D]/20', bg: 'bg-[#F29B3D]/[0.07]', icon: 'text-[#F29B3D]', topBar: 'via-[#F29B3D]/40' }
};

export const LinkListMenu = ({ items, testIdPrefix, accent = 'cyan', width = 'w-[320px]' }) => {
  const a = ACCENTS[accent];
  return (
    <div className={`bg-[#120836] border border-white/10 rounded-2xl shadow-[0_30px_80px_rgba(0,0,0,0.5)] p-4 ${width} relative overflow-hidden`}>
      <div className={`absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent ${a.topBar} to-transparent`} />
      <div className="space-y-0.5">
        {items.map((item) => {
          const Icon = item.icon;
          return (
            <Link
              key={item.name}
              to={item.href}
              data-testid={`${testIdPrefix}-${item.name.toLowerCase().replace(/\s+/g, '-')}`}
              className="flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-white/[0.05] transition-colors duration-150 group/item"
            >
              <span className="min-w-0">
                <span className="block text-[13px] font-medium text-[#DCE4EE] group-hover/item:text-white leading-snug transition-colors">{item.name}</span>
                <span className="block text-[11px] text-[#94A3B8]">{item.desc}</span>
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
};
